import { render, staticRenderFns } from "./ReplyList.vue?vue&type=template&id=954e3e28"
import script from "./ReplyList.vue?vue&type=script&lang=js"
export * from "./ReplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports